import { AUTOPILOT_LIMITS } from "@auto-pools/core";

/**
 * Mirrors `apps/server/src/autopilot/commands.ts`'s `DRAWDOWN` regex exactly (review B5): no
 * leading zero (except a bare "0"), at most one decimal digit. A client predicate that is looser
 * than the server's lets an enabled Save/Start submit a value `validateLimits()` then rejects.
 */
const DRAWDOWN = /^(0|[1-9]\d{0,2})(\.\d)?$/;

export function drawdownLimitValid(value: string): boolean {
  return (
    DRAWDOWN.test(value) &&
    Number(value) >= Number(AUTOPILOT_LIMITS.drawdownPercent.min) &&
    Number(value) <= Number(AUTOPILOT_LIMITS.drawdownPercent.max)
  );
}

export function entriesLimitValid(value: string): boolean {
  return (
    /^\d+$/.test(value) &&
    Number(value) >= AUTOPILOT_LIMITS.entriesPer24h.min &&
    Number(value) <= AUTOPILOT_LIMITS.entriesPer24h.max
  );
}
